module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_5012.6cd47ca0.png";